import React from 'react';
import { Alert, Typography } from '@mui/material';
import { PlayerCardLayout } from '../../components/PlayerCardLayout';

export function RoundCompletePage({ header, assignedLabel, completionMessage }) {
  return (
    <PlayerCardLayout header={header}>
      <Alert severity="success">{assignedLabel}</Alert>
      <Typography variant="h4">Čestitamo!</Typography>
      <Typography>{completionMessage}</Typography>
      <Typography>Pripremamo otključavanje idućeg kruga...</Typography>
    </PlayerCardLayout>
  );
}
